<!-- 新增店员 -->
<template>
  <div class="edit white">
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains" v-if="addEditShow">
          <el-form ref="form" :model="form" class="demo-ruleForm" label-width="140px" label-position="left">
            <p class="order-title-boxs mb0"><span class="blueBlock"></span><i>基本信息</i></p>
            <div class="head-img mt20 mb20">
              <imgUploadHead @file="getFile" :fileList="form.headImgUrl" module="head" :show="false"></imgUploadHead>
            </div>
            <el-row class="borderT">
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="staffName" label="姓名：" prop="staffName"
                  :rules="$rules.required">
                  <el-input v-model="form.staffName" placeholder="请输入店员姓名" :disabled='!editFlag'
                    :maxlength="30"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="gender" label="性别：" prop="gender"
                  :rules="$rules.changeIred">
                  <el-select v-model="form.gender" placeholder="请选择" class="w100b" :disabled='!editFlag'>
                    <el-option label="男" value="male"></el-option>
                    <el-option label="女" value="female"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12" v-if="(!form.id || isReferences) && !userInfo.shopBizConfig.easyStaffFlag">
                <el-form-item class="el-form-item-update" ref="technType" label="技师类型：" prop="technType"
                  :rules="$rules.changeIred">
                  <el-select v-model="form.technType" placeholder="请选择" class="w100b">
                    <el-option label="新技师" value="newly"></el-option>
                    <el-option label="老技师" value="old"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="(!form.id || isReferences) && !userInfo.shopBizConfig.easyStaffFlag">
                <el-form-item class="el-form-item-update" ref="jobIdentity" label="技师身份：" prop="jobIdentity"
                  :rules="$rules.changeIred">
                  <el-select v-model="form.jobIdentity" placeholder="请选择" class="w100b">
                    <el-option label="正式" value="formal"></el-option>
                    <el-option label="兼职" value="partTime"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12" v-if="userInfo.manageModel == 'group'">
                <el-form-item class="el-form-item-update" label="补充资料：" required>
                  <el-input v-model="supplementaryCn" readonly="" placeholder="请填写补充资料" @focus="supplementaryChange"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12"
                v-if="(!form.id || isReferences) && !userInfo.shopBizConfig.easyStaffFlag && form.jobIdentity == 'formal'">
                <el-form-item class="el-form-item-update" ref="guaranteeFlag" label="技师入职补助：" prop="guaranteeFlag"
                  :rules="$rules.changeIred">
                  <el-select v-model="form.guaranteeFlag" placeholder="请选择" class="w100b">
                    <el-option label="是" value="yes"></el-option>
                    <el-option label="否" value="no"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="staffNo" label="店员工号：" prop="staffNo"
                  :rules="$rules.required" v-if="form.id">
                  <el-input v-model="form.staffNo" :disabled='true' placeholder="请输入店员工号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="positionId" label="职位：" prop="positionId"
                  :rules="$rules.changeIred">
                  <el-select v-model="form.positionId" class="w100b" placeholder="请选择" :disabled="form.auditStatus && form.auditStatus == 'pass'">
                    <el-option v-for="(item, index) in positionList" :key="index" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-if="(!form.id || isReferences) && !userInfo.shopBizConfig.easyStaffFlag"
                  class="el-form-item-update" ref="joinTime" label="入职时间：" prop="joinTime" :rules="$rules.required">
                  <el-date-picker v-model="form.joinTime" value-format="yyyy-MM-dd" type="date" :picker-options="beginPickerOptions" placeholder="选择日期"
                    popper-class="el-date-picker" class="w100b">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="roleIdList" label="关联角色：" prop="roleIdList"
                  :rules="$rules.changeIred">
                  <el-select v-model="form.roleIdList"  multiple collapse-tags  class="w100b">
                    <el-option v-for="it in roleList" :key="it.id" :value="it.id" :label="it.roleName"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="idCardNo" label="身份证号码：" prop="idCardNo"
                  :rules="$rules.cardNum" v-if="!userInfo.shopBizConfig.easyStaffFlag">

                  <el-input v-model="form.idCardNo" maxlength="18" placeholder="请输入身份证号码" @blur="idCardBlur"
                    :disabled='!editFlag'></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" label="证件到期时间：" v-if="userInfo.shopBizConfig.yuanyuanFlag">

                  <el-input placeholder="请选择" v-model="cardTime" readonly="" @focus="timeChange">
                    <i slot="suffix" class="el-input__icon el-icon-arrow-down jishi"></i>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="(!form.id || isReferences) && !userInfo.shopBizConfig.easyStaffFlag">
                <el-form-item class="el-form-item-update" ref="source" label="招聘渠道：" prop="source"
                  :rules="$rules.changeIred">
                  <el-select v-model="form.source" placeholder="请选择" class="w100b" :disabled="form.isJoin">
                    <el-option label="人资代招" value="hrInvite"></el-option>
                    <el-option label="门店自招" value="shopInvite"></el-option>
                    <el-option label="内部介绍" value="insideRecommend"></el-option>
                    <el-option label="学校学员" value="student"></el-option>
                    <el-option label="第三方机构" value="thirdPartyOrganization"></el-option>
                    <el-option label="再次入职" value="reEntry" :disabled="true"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="urgentContactName" label="紧急联系人：" prop="urgentContactName">
                  <el-input v-model="form.urgentContactName" readonly="" @focus="addContactPerson" placeholder="请输入紧急联系人"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12"
                v-if="!form.id && !userInfo.shopBizConfig.easyStaffFlag && form.source == 'insideRecommend'">
                <el-form-item class="el-form-item-update" ref="introducer" label="介绍人：" prop="introducer">
                  <el-input readonly v-model="form.introducer" placeholder="请输入介绍人" @focus="addReferences"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="bankCardNo" label="银行卡号："
                  v-if="userInfo.shopBizConfig.yuanyuanFlag">
                  <el-input readonly v-model="form.bankCardNo" placeholder="请输入银行卡号" maxlength="19"
                    @focus="addBank"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="mobile" label="手机号码：" prop="mobile"
                  :rules="$rules.required" v-if="form.auditStatus == 'pass'">
                  <!-- <el-input placeholder="请输入手机号码" v-model="form.mobile"  maxlength="11">
                    <el-button slot="suffix" size="mini" type="primary" class="cur elButton" @click="reset">重置</el-button>
                  </el-input> -->
                  <el-input readonly v-model="form.mobile" placeholder="请输入手机号码" maxlength="11"
                    @focus="updateMobile"></el-input>
                </el-form-item>
                <el-form-item class="el-form-item-update" ref="mobile" label="手机号码：" prop="mobile"
                  :rules="$rules.required" v-else>
                  <el-input :disabled='form.id ? true : false' v-model="form.mobile" placeholder="请输入手机号码"
                    maxlength="11"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="password" label="账号密码：" prop="password"
                  :rules="$rules.required" v-if="!form.id">
                  <el-input v-model="form.password" show-password autocomplete="new-password" placeholder="请输入账号密码"
                    maxlength="6"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="confirmPassword" label="确认密码：" prop="confirmPassword"
                  :rules="$rules.required" v-if="!form.id">
                  <el-input v-model="form.confirmPassword" autocomplete="off" show-password placeholder="请输入确认密码"
                    maxlength="6"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <p class="order-title-boxs mb0" v-if="!userInfo.shopBizConfig.easyStaffFlag"><span
                class="blueBlock"></span><i>证件信息</i>(<span class="moneys">请上传清晰身份证照片，否则审核不予通过</span>)</p>
            <el-form-item class="item-cards mt20" ref="idCardFrontUrl" v-if="!userInfo.shopBizConfig.easyStaffFlag"
              disabled>
              <div class="idcard">
                <el-form-item prop="idCardFrontUrl">
                  <div class="front card-box">
                    <imgUploads @file="getFileCardFront" :fileList="idCardFrontUrl" module="idcard" type="front">
                    </imgUploads>
                    <p><span class="moneys">*</span> 身份证正面拍照</p>
                  </div>
                </el-form-item>
                <el-form-item prop="idCardBackUrl">
                  <div class="back card-box">
                    <imgUploads @file="getFileCarBack" :fileList="idCardBackUrl" module="idcard" type="reverse">
                    </imgUploads>
                    <p><span class="moneys">*</span> 身份证反面拍照</p>
                  </div>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item class="item-cards mt20" ref="bankCardUrl" v-if="!userInfo.shopBizConfig.easyStaffFlag" disabled>
              <div class="idcard">
                <div class="idcard"
                  v-if="!userInfo.shopBizConfig.easyStaffFlag && form.bankCardAccountType && form.bankCardAccountType != 'otherAccount'">
                  <el-form-item ref="bankCardUrl" prop="bankCardUrl">
                    <div class="front card-box">
                      <imgUpload @file="getbankUrl" :fileList="form.bankCardUrl" @delete="handlebankUrl"
                        module="bankCard"></imgUpload>
                      <p><span class="moneys"></span> 银行卡</p>
                    </div>
                  </el-form-item>
                </div>
                <div class="idcard" v-if="form.bankCardAccountType == 'otherAccount'">
                  <el-form-item prop="agentBookUrl" ref="agentBookUrl">
                    <div class="card-box cardWite">
                      <imgUpload @file="getagentBookUrl" :fileList="form.agentBookUrl" @delete="handleAgentBookUrl"
                        module="agentBook"></imgUpload>
                      <p><span class="moneys"></span> 委托书</p>
                    </div>
                  </el-form-item>
                </div>
                <div class="idcard" v-if="form.bankCardAccountType == 'otherAccount'">
                  <el-form-item prop="handImgUrl" ref="handImgUrl">
                    <div class="card-box cardWite back">
                      <imgUpload @file="getHandImgUrl" :fileList="form.handImgUrl" @delete="handleHandImgUrl"
                        module="agentBook"></imgUpload>
                      <p><span class="moneys"></span> 手持委托书</p>
                    </div>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>

            <el-col :span="24">
              <el-form-item label="备注：" class="el-form-item-update" :rules="$rules.required"
                v-if="form.auditStatus == 'pass'">
                <el-input v-model="form.remark" type="textarea" placeholder="请输入备注" maxlength="50"
                  show-word-limit></el-input>
              </el-form-item>
            </el-col>

          </el-form>
        </div>
        <div class="drawer-footer pr24 pb10">
          <div v-if="form.auditStatus == 'pass'">
            <el-button @click="back">取消</el-button>
            <el-button type="primary" class="ml10" @click="save">确定</el-button>
          </div>
          <div class="flex-row" v-else>
            <el-button @click="back">取消</el-button>
            <div v-if="!(form.auditStatus == 'pass' && userInfo.manageModel == 'group')">
              <el-button type="primary" class="ml10" @click="save">确定</el-button>
            </div>
          </div>
        </div>
      </div>
    </drawer>
    <add-bank ref="bankForm" @change="bankChange"></add-bank>
    <add-references ref="referencesForm" @change="referencesChange"></add-references>
    <add-mobile ref="mobileForm" @change="mobileChange"></add-mobile>
    <contact-person ref="personRef" @change="contactChange"></contact-person>
    <sms-module-vue ref="smsModuleRef" @smsBack="onSmsBack"></sms-module-vue>
    <id-card-time ref="cradTimeRef" @change="cardTimeChange"></id-card-time>
    <add-supplementary-info ref="addSupplementaryInfoRef" @change="onSupplementtary"></add-supplementary-info>
  </div>
</template>

<script>
import imgUploads from "../../../components/common/modules/uploads";
import imgUpload from "../../../components/common/modules/singleUpload.vue";
import imgUploadHead from "../../../components/common/modules/upload-head";
import drawer from "../../../components/common/drawer";
import minxin from "../../../assets/javascript/minxin.js";
import addBank from "./addBank.vue";
import addReferences from "./references.vue";
import addMobile from "./updateMobile.vue";
import contactPerson from "./addContactPerson.vue";
import smsModuleVue from './smsModule.vue';
import idCardTime from "./idCardTime.vue";
import addSupplementaryInfo from "./addSupplementaryInfo.vue";
export default {
  data() {
    return {
      addEditShow: false,
      addEditTitle: "",
      positionList: [],
      form: {
        staffName: "", //姓名
        gender: "", //性别 默认男
        source: "", // 招聘渠道
        jobIdentity: "", // 技师身份
        guaranteeFlag: "", //
        technType: "", //性别 默认 新技师
        positionId: "", //选择职位
        mobile: "", //联系电话
        verifyCode: "", //验证码
        bankCardUrl: '',
        handImgUrl: "",
        staffNo: "",
        bankCardNo: '', // 银行卡号
        idCardBackUrl: "", //身份证反面
        idCardFrontUrl: "", //身份证正面
        idCardNo: "", //身份证号码
        headImgUrl: "", //身份证头像
        confirmPassword: "", // 密码
        password: "", // 确认密码
        joinTime: '', //入职时间
        agentBookUrl: '',
        bankCardAccountType: '',
        agentStaffName: '',
        agentStaffNo: '',
        bankId: '',
        bankNoImg: '',
        accountName: '',
        bankId: '',
        bankName: '',
        subBankName: '',
        bankNo: '',
        introducerId: '',
        introducer: '',
        remark: '',
        canEdit: true,
        isJoin: false,
        roleIdList: [],
        urgentContactName: '',
        urgentContactMobile: '',
        relationWithMe: '',
        idCardValidEndTime: '', // 证件时间
        idCardTimeType: '', // 证件时间类型
        bankMobile: '', // 预留手机号
        bankFullName: ''
      },
      idCardFrontUrl: '',
      idCardBackUrl: '',
      paramsId: 0,
      userInfo: {
        manageModel: '',
        shopBizConfig: {

        }
      },
      editFlag: false,
      isReferences: false,
      roleList: [],
      cardTime: '',
      supplementaryCn: ''
      //attachmentList: [],
    };
  },
  mixins: [minxin],
  components: {
    imgUpload,
    imgUploads,
    imgUploadHead,
    drawer,
    addBank,
    addReferences,
    addMobile,
    contactPerson,
    smsModuleVue,
    idCardTime,
    addSupplementaryInfo
  },

  computed: {
    beginPickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now() + (24 * 60 * 60 * 1000);
        }
      };
    }
  },

  created() {
    this.form.headImgUrl = "";
  },
  methods: {
    back() {
      this.addEditShow = false;
      this.$refs['form'].resetFields();
    },
    reset() {
      this.form = {
        staffName: "", //姓名
        gender: "", //性别 默认男
        source: "", // 招聘渠道
        jobIdentity: "", // 技师身份
        guaranteeFlag: "", // 
        technType: "", //性别 默认 新技师
        positionId: "", //选择职位
        mobile: "", //联系电话
        verifyCode: "", //验证码
        bankCardUrl: '',
        handImgUrl: "",
        bankCardNo: '', // 银行卡号
        idCardBackUrl: "", //身份证反面
        idCardFrontUrl: "", //身份证正面
        idCardNo: "", //身份证号码
        headImgUrl: "", //身份证头像
        confirmPassword: "", // 密码
        password: "", // 确认密码
        joinTime: '', //入职时间
        agentBookUrl: '',
        bankCardAccountType: '',
        agentStaffName: '',
        agentStaffNo: '',
        staffNo: "",
        accountName: '',
        bankId: '',
        bankName: '',
        subBankName: '',
        bankNo: '',
        introducerId: '',
        introducer: '',
        remark: '',
        canEdit: true,
        isJoin: false,
        roleIdList: [],
        urgentContactName: '',
        urgentContactMobile: '',
        relationWithMe: '',
        idCardValidEndTime: '', // 证件时间
        idCardTimeType: '', // 证件时间类型
        bankMobile: '', // 预留手机号
        bankFullName: '',
        bankNoImg: '',

        politicalAffiliation: '',
        accommodationType: '',
        maritalStatus: '',
        idCardAddress: '',
        height: '',
        weight: '',
        degreeOfEducation: '',
        graduatedSchool: '',
        professional: '',
        healthCertificateHandleTime: '',
        healthTime: '',
        healthCertificateImgUrl: '',
        healthImgUrlList: [],
      }
      this.idCardFrontUrl = ''
      this.idCardBackUrl = ''
      this.cardTime = ''
      this.supplementaryCn = ''
    },
    bankChange(org) {
      // 添加银行卡回调
      if (org) {
        console.log(org);
        let obj = JSON.parse(sessionStorage.getItem("bankData"));
        if (this.form.bankCardAccountType != obj.bankCardAccountType && this.form.bankCardAccountType) {
          this.form.agentBookUrl = '';
          this.form.handImgUrl = '';
          this.form.bankCardUrl = '';
        }
        this.form.accountName = obj.accountName;
        this.form.bankId = obj.bankId;
        this.form.bankName = obj.bankName;
        this.form.bankCardNo = obj.bankCardNo;
        this.form.subBankName = obj.subBankName;
        this.form.bankNo = obj.bankNo;
        this.form.bankCardAccountType = obj.bankCardAccountType;
        this.form.agentStaffId = obj.agentStaffId;
        this.form.agentStaffName = obj.agentStaffName;
        this.form.bankMobile = obj.bankMobile;
        this.form.bankFullName = obj.bankFullName || obj.bankName;
        this.form.bankNoImg = obj.bankNoImg;
      }
    },
    referencesChange() {
      let obj = JSON.parse(sessionStorage.getItem("referencesData"));
      console.log('数据：', obj);
      this.form.introducer = obj.introducer;
      this.form.introducerId = obj.introducerId;
    },
    mobileChange(org) {
      // 修改手机号回调
      if (org) {
        console.log(org);
        let obj = JSON.parse(sessionStorage.getItem("mobileChange"));
        this.form.mobile = obj.mobile;
        this.form.verifyCode = obj.verifyCode;
        sessionStorage.removeItem("mobileChange");
      }
    },
    onSupplementtary (val) {
      this.supplementaryCn = '已填写'
      this.form.politicalAffiliation = val.politicalAffiliation
      this.form.accommodationType = val.accommodationType
      this.form.maritalStatus = val.maritalStatus
      this.form.idCardAddress = val.idCardAddress
      this.form.height = val.height
      this.form.weight = val.weight
      this.form.degreeOfEducation = val.degreeOfEducation
      this.form.graduatedSchool = val.graduatedSchool
      this.form.professional = val.professional
      this.form.healthCertificateHandleTime = val.healthCertificateHandleTime
      this.form.healthTime = val.healthTime
      this.form.healthCertificateImgUrl = val.healthCertificateImgUrl
      this.form.healthImgUrlList = val.healthImgUrlList
    },
    // 上传组件成功回调
    getFile(res) {
      if (!this.form.id && this.form.headImgUrl) {
        this.ossMerchatDelImg({ imgUrl: this.form.headImgUrl });
      }
      this.form.headImgUrl = res;
    },
    getFileCardFront(res) {
      //身份证正面
      if (!this.form.id && this.form.idCardFrontUrl) {
        this.ossMerchatDelImg({ imgUrl: this.form.idCardFrontUrl });
      }
      this.form.idCardFrontUrl = res.oldImgUrl;
      this.idCardFrontUrl = res.newImgUrl;
    },
    getFileCarBack(res) {
      //身份证反面
      if (!this.form.id && this.form.idCardBackUrl) {
        this.ossMerchatDelImg({ imgUrl: this.form.idCardBackUrl });
      }
      this.form.idCardBackUrl = res.oldImgUrl;
      this.idCardBackUrl = res.newImgUrl;
    },
    getbankUrl(res) {
      // 银行卡
      this.form.bankCardUrl = res;
    },
    getagentBookUrl(res) {
      // 委托书
      this.form.agentBookUrl = res;
    },
    getHandImgUrl(res) {
      // 手持委托书
      this.form.handImgUrl = res;
    },
    handlebankUrl(res) {
      this.form.bankCardUrl = '';
      if (!this.form.id) {
        this.ossMerchatDelImg(res);
      }
    },
    handleAgentBookUrl(res) {
      this.form.agentBookUrl = '';
      if (!this.form.id) {
        this.ossMerchatDelImg(res);
      }
    },
    handleHandImgUrl(res) {
      this.form.handImgUrl = '';
      if (!this.form.id) {
        this.ossMerchatDelImg(res);
      }
    },
    //  页面初始化函数
    companyPositionPage() {
      this.$api.post(this.$url.companyPosition.page, { size: 100 }).then(res => {
        this.positionList = res;
      });
    },
    init(row) {
        this.companyPositionPage();
        sessionStorage.removeItem("referencesData");
        sessionStorage.removeItem("bankData");
        this.userInfo = this.$store.getters.ShopInfo;
        console.log(this.userInfo);
        if (row.id != 0) {
          this.paramsId = row.id;
          if (row.isResubmit) {
            this.isReferences = true;
          } else {
            this.isReferences = false;
          }
          this.addEditTitle = "修改资料";
          this.getRoleList(row.id)
          this.$api
            .get(this.$url.companyShopStaff.get, {
              id: row.id
            })
            .then(res => {
              if (res) {
                this.idCardFrontUrl = res.idCardFrontUrl;
                this.idCardBackUrl = res.idCardBackUrl;
                if (res.source == 'reEntry') {
                  res.isJoin = true;
                } else {
                  res.isJoin = false;
                }
                this.form = res;
                if (res.politicalAffiliation && res.maritalStatus) {
                  this.supplementaryCn = '已填写'
                }
                if (res.roleIdList.length>0) {
                  this.form.roleIdList = res.roleIdList
                }else{
                  this.form.roleIdList = ['69B42B7E2718A405']
                }
                if (res.idCardTimeType == 'permanentlyValid' && this.userInfo.shopBizConfig.yuanyuanFlag) {
                  this.cardTime = '永久有效'
                } else if (this.userInfo.shopBizConfig.yuanyuanFlag) {
                  this.cardTime = this.$tools.format(res.idCardValidEndTime)
                  this.form.idCardValidEndTime = this.$tools.format(res.idCardValidEndTime)
                }
                this.form.bankId = String(res.bankId);
                this.form.joinTime = this.formatDate(this.form.joinTime)
                if (this.form.healthCertificateHandleTime) this.form.healthCertificateHandleTime = this.formatDay(this.form.healthCertificateHandleTime)
                if (this.form.healthTime) this.form.healthTime = this.formatDay(this.form.healthTime)
                if (this.form.headImgUrl == null) {
                  this.form.headImgUrl = "";
                }

                this.addEditShow = true;
                if (this.form.canEdit) {
                  this.editFlag = true;
                } else {
                  this.editFlag = false;
                }
              }
            });
        } else {
          this.reset()
          if (this.$refs["form"]) this.$refs["form"].resetFields()
          this.addEditTitle = "新增店员";
          this.addEditShow = true;
          this.paramsId = 0;
          this.editFlag = true;
          this.getRoleList('')
          this.form.roleIdList = ['69B42B7E2718A405']
        }
    },
    handleChangeDrawer (val) {
      this.addEditShow = false;
    },
    idCardBlur() {
      console.log(this.form.idCardNo);
      if (this.form.idCardNo.length == 18) {
        this.$api.post(this.$url.companyQuit.listByIdCardNo, { idCardNo: this.form.idCardNo }).then(res => {
          if (res) {
            this.form.isJoin = true;
            this.form.sourceCn = '再次入职';
            this.form.source = 'reEntry';
          } else {
            this.form.isJoin = false;
          }
        });
      }
    },
    isYuanyuanJoinFlag () {
      return new Promise((resolve, reject) => {
        this.$api.post(this.$url.companyShopStaff.getShowMessageInfo, {idCardNo: this.form.idCardNo, joinTime: this.form.joinTime}).then(res => {
          if (res) {
            console.log(res, 'res');
            if (res.showFlag) {
              this.$confirm('该人员3个月内从' + res.remark + '离职，请确认是否仍要入职当前门店', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
              }).then(() => {
                resolve(true)
              }).catch(() => {
                resolve(false)        
              });
            } else {
              resolve(true)
            }
          }
        });
      })
    },
    // 保存
    save() {
      console.log("this.form.joinTime: ", this.userInfo.shopBizConfig);
      if (!this.form.headImgUrl && !this.userInfo.shopBizConfig.easyStaffFlag) {
        return this.$message.error("请上传店员照片")
      }
      this.$refs.form.validate(async (valid, object) => {
        if (valid) {
          if (this.userInfo.manageModel == 'group' && !this.form.politicalAffiliation) {
            return this.$message.error("请填写补充资料")
          }
          if (!this.form.idCardTimeType && this.userInfo.shopBizConfig.yuanyuanFlag) {
            this.$message.error('请选择证件到期时间');
            return false;
          }
          if (this.userInfo.manageModel == "group") {
            if (!this.form.urgentContactName) {
              return this.$message.error("请输入紧急联系人姓名");
            } else if (!this.form.urgentContactMobile) {
              return this.$message.error("请输入手机号码");
            } else if (!this.form.relationWithMe) {
              return this.$message.error("请输入与本人关系");
            }
          }
          if (!this.form.introducer && this.form.source == 'insideRecommend') {
            this.$message.error("请填写介绍人")
            return false;
          }
          
          this.form.joinTime = this.formatDay(this.form.joinTime);
          this.form.idCardValidEndTime = this.formatDay(this.form.idCardValidEndTime);
          if (this.form.bankCardUrl || this.form.agentBookUrl) {
            if (!this.form.bankCardNo) {
              return this.$message.error("请输入银行卡号")
            }
          }
          if (!this.form.idCardFrontUrl && !this.userInfo.shopBizConfig.easyStaffFlag) {
            this.$message.error('请上传身份证正面');
            return false;
          }
          if (!this.form.idCardBackUrl && !this.userInfo.shopBizConfig.easyStaffFlag) {
            this.$message.error('请上传身份证反面');
            return false;
          }
          if (!this.userInfo.shopBizConfig.easyStaffFlag && this.form.agentBookUrl && !this.form.accountName && this.form.bankCardAccountType == 'otherAccount') {
            this.$message.error('请填写受委托人');
            return false;
          }
          if (this.form.bankCardNo && !this.form.bankCardUrl && this.form.bankCardAccountType == 'myAccount') {
            return this.$message.error("请上传银行卡照片")
          }
          if (!this.form.agentBookUrl && this.form.bankCardAccountType == 'otherAccount') {
            return this.$message.error("请上传委托书照片")
          }
          if (!this.form.handImgUrl && this.form.bankCardAccountType == 'otherAccount') {
            return this.$message.error("请上传手持委托书照片");
          }
          if (!this.paramsId && this.form.password.length < 6) {
            return this.$message.error("密码不能少于6位")
          } else if (!this.paramsId && this.form.confirmPassword != this.form.password) {
            return this.$message.error("两次密码不一致")
          }
          if (this.form.auditStatus == "pass" && !this.form.remark) {
            this.$message.error("请输入备注")
            return false;
          }

          if (this.form.idCardNo && (this.form.idCardNo.length == 18 || this.form.idCardNo.length == 15)) { 
            const result = this.isIdCardAgeOver50(this.form.idCardNo);
            if (result.isOver50) { 
              this.$confirm('录入人员已经年满五十周岁，请您注意用人风险，确认是否录用?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.confirmSave()
              }).catch(() => {});
            } else {
              this.confirmSave()
            }
          } else {
            this.confirmSave()
          }
        } else {
          this.scrollView(object);
        }
      });
    },
    async confirmSave () {
      if (this.paramsId == 0) {
        this.$api.get(this.$url.companyStaff.joinOtherTenantCountByMobile, { mobile: this.form.mobile }).then(res => {
          if (res === 0) {
            this.saveFunc()
          } else if (res && res > 0){
            this.$refs.smsModuleRef.open({mobile: this.form.mobile})
          }
        });
      } else {
        if (!this.userInfo.shopBizConfig.easyStaffFlag) {// 非简易
          if (this.form.auditStatus == 'pass') {
            this.$api.post(this.$url.companyShopStaff.passApply, this.form).then(res => {
              if (res) {
                this.$api.success();
                this.addEditShow = false;
                this.$emit("handleChange", false);
              }
            });
          } else { // 重新入职
            let result = await this.isYuanyuanJoinFlag()
            console.log(result);
            if (result) {
              this.$api.post(this.$url.companyShopStaff.update, this.form).then(res => {
                if (res) {
                  this.$api.success();
                  this.addEditShow = false;
                  this.$emit("handleChange", false);
                }
              });
            }
          }
        } else {
          if (this.form.auditStatus == 'pass') {
            this.$api.post(this.$url.companyShopStaff.easyApply, this.form).then(res => {
              if (res) {
                this.$api.success();
                this.addEditShow = false;
                this.$emit("handleChange", false);
              }
            });
          } else {
            this.$api.post(this.$url.companyShopStaff.easyUpdate, this.form).then(res => {
              if (res) {
                this.$api.success();
                this.addEditShow = false;
                this.$emit("handleChange", false);
              }
            });
          }
        }
      }
    },
    async saveFunc () {
      console.log(11111);
      if (!this.userInfo.shopBizConfig.easyStaffFlag) { // 非简易
        let result = await this.isYuanyuanJoinFlag()
        console.log(result);
        if (result) {
          this.$api.post(this.$url.companyShopStaff.save, this.form).then(res => {
            if (res) {
              this.$api.success();
              this.addEditShow = false;
              this.$emit("handleChange", false);
            }
          });
        }
      } else {
        this.$api.post(this.$url.companyShopStaff.easyAdd, this.form).then(res => {
          if (res) {
            this.$api.success();
            this.addEditShow = false;
            this.$emit("handleChange", false);
          }
        });
      }
    },
    addBank() {
      this.$refs["bankForm"].$emit("set", this.form);
    },
    addContactPerson () {
      this.$refs.personRef.init({urgentContactName: this.form.urgentContactName,urgentContactMobile: this.form.urgentContactMobile,relationWithMe: this.form.relationWithMe})
    },
    addReferences() {
      this.$refs["referencesForm"].$emit("set", JSON.parse(JSON.stringify(this.form)));
    },
    updateMobile() {
      this.$refs["mobileForm"].$emit("set", this.form);
    },

    // //滚动到指定位置
    scrollView(object) {
      for (let i in object) {
        let dom = this.$refs[i];
        dom.$el.scrollIntoView({
          block: "center",
          behavior: "smooth"
        });
        break;
      }
    },
    // 获取角色列表
    async getRoleList(staffId) {
      const res = await this.$api.post(this.$url.auth.listOptionalRole, { staffId: staffId })
      console.log(res);
      this.roleList = res
    },
    contactChange (val) {
      this.form.urgentContactName = val.urgentContactName;
      this.form.urgentContactMobile = val.urgentContactMobile;
      this.form.relationWithMe = val.relationWithMe;
    },
    onSmsBack (arg) {
      if (arg) this.saveFunc()
    },
    timeChange () {
      this.$refs.cradTimeRef.open({idCardTimeType: this.form.idCardTimeType, idCardValidEndTime: this.form.idCardValidEndTime})
    },
    cardTimeChange (e) {
      this.form.idCardTimeType = e.idCardTimeType
      this.form.idCardValidEndTime = e.idCardValidEndTime
      this.cardTime = e.idCardTimeType == 'permanentlyValid' ? '永久有效' : e.idCardValidEndTime
    },
    supplementaryChange () {
      this.$refs.addSupplementaryInfoRef.open(this.form)
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

.pay-mains {
  padding: 0;
  height: 100%;

  /deep/ .el-input-group__append {
    padding: 0 10px !important;
  }

  .item-cards {
    padding: 0 20px;

    .idcard {
      display: flex;

      .card-box {
        p {
          margin-top: 10px;
        }

        text-align: center;
      }

      .back {
        margin-left: 35px;
      }
    }

    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  /deep/ .el-form {
    /deep/ .el-form-item {
      background: #fff;
      padding: 10px 20px;
    }

    .head-img {
      width: 100%;
      box-sizing: border-box;
      background: #fff;
    }
  }

  .cardWite {
    width: 220px;
  }
}
</style>
